// @ts-strict-ignore
import { Body, Heading, Scales } from "components/parts/Typography";
import styled from "styled-components";

export const FeaturedPostContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.borderColors.primary};
  grid-template-columns: 1fr;
  background-color: white;
  border-radius: 8px;
  cursor: pointer;
  display: grid;
  margin: 32px;
  padding: 0;
  ${({ active }) =>
    active &&
    `
    filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.08));  
  `}
  ${(props) => props.theme.media.tablet`
      max-width: 837px;
  `}
  ${(props) => props.theme.media.desktop`
      max-width: unset;
      grid-template-columns: 1.5fr 1fr;
  `}
`;

export const PostImgContainer = styled.div`
  height: 100%;

  img {
    border-bottom: 2px solid ${({ theme }) => theme.borderColors.primary};
    border-radius: 8px 8px 0 0;
    width: 100%;
    height: 100%;
  }

  ${(props) => props.theme.media.desktop`
    margin-right: 24px;
    > picture {
      > img {
        border-right: 2px solid ${({ theme }) => theme.borderColors.primary};
        border-radius: 8px 0 0 8px;
        border-bottom: none;
      }
    }
  `}
`;

export const PostDetailsContainer = styled.div`
  margin: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${(props) => props.theme.media.desktop`
    margin: 24px 24px 24px 0; 
  `}
`;

export const PostDetailsInner = styled.div`
  display: flex;
  p:last-child {
    margin-left: 8px;
  }
`;

export const PostTitle = styled(Heading).attrs({ m: "8px 0" })``;

export const PostAuthorDetails = styled.div`
  display: flex;
  margin-top: 24px;
  cursor: pointer;
  ${({ active }) =>
    active &&
    `
    text-decoration: underline;
    p {
      color: unset;
    }
  `}
`;

export const PostAuthorDetailsInner = styled.div`
  justify-content: center;
  flex-direction: column;
  display: flex;
`;

export const StyledAuthorImgContainer = styled.div`
  border-radius: 50%;
  width: 48px;
  margin-right: 16px;
`;

export const GreyText = styled(Body).attrs({
  size: "md",
  m: "0",
  sm: Scales.scale2,
  color: "secondary"
})``;
